import React, { useEffect, useState } from "react";
import "./Department.css";
import { BsPencil } from "react-icons/bs";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { DeleteOutlined, PlusOutlined, StopOutlined } from "@ant-design/icons";
import {
  BASE_URL,
  DeleteDepartment,
  FetchDepartment,
  UpdateDepartment,
  UpdateSubDepartment,
} from "../../utils/constant";
import DepartmentForm from "../Department&subDepartment/DepartmentForm";
import SubDepartmentForm from "../Department&subDepartment/SubDepartmentForm";
import EditIcon from "../../assets/icons/add.svg";
import DeleteIcon from "../../assets/icons/bin.svg";
import { CiCirclePlus } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import { setDesig } from "../../store/slices/designationSlice";
import { setDept } from "../../store/slices/departmentSlice";
import ModalConfirm from "../../common/modalConfirm";
function Department() {
  const dispatch = useDispatch();

  const [departmentData, setDepartmentData] = useState([]);
  const [departmentDisabledData, setDepartmentDisabledData] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editDepartmentData, setEditDepartmentData] = useState(null);
  const [openSubDeptForm, setOpenSubDeptForm] = useState(false);
  const [editSubDeptFormData, setEditSubDeptFormData] = useState(null);
  const [departmentId, setDepartmentId] = useState(null);
  const [subDeptID, setSubDeptID] = useState(null);
  const designations = useSelector((state) => state.designation.designation);
  const [modalDeleteDeptVisible, setModalDeleteDeptVisible] = useState(false);
  const [deleteDeptData, setDeleteDeptData] = useState(null);

  const deleteDept = (params) => {
    setModalDeleteDeptVisible(true);
    setDeleteDeptData(params);
  };
  const handleOk = (params) => {
    deleteDepartment(params);
    setModalDeleteDeptVisible(false);
  };
  const handleCancel = () => {
    setModalDeleteDeptVisible(false);
  };
  const [modalDeleteSubDeptVisible, setModalDeleteSubDeptVisible] =
    useState(false);
  const [deleteSubDeptData, setDeleteSubDeptData] = useState(null);

  const deleteSubDept = (params) => {
    setModalDeleteSubDeptVisible(true);
    setDeleteSubDeptData(params);
  };
  const handleSubOk = (params) => {
    deleteSubDepartment(params);
    setModalDeleteSubDeptVisible(false);
  };
  const handleSubCancel = () => {
    setModalDeleteSubDeptVisible(false);
  };
  const [activeDepartmentData, setActiveDepartmentData] = useState(null);
  const [modalActiveDepartmentVisible, setModalActiveDepartmentVisible] =
    useState(false);

  const activeBtnDepartment = (params) => {
    setModalActiveDepartmentVisible(true);
    setActiveDepartmentData(params);
  };
  const handleActiveOk = (params) => {
    activeDepartment(params);
    setModalActiveDepartmentVisible(false);
  };
  const handleActiveCancel = () => {
    setModalActiveDepartmentVisible(false);
  };
  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const activeDepartment = (data) => {
    const token = localStorage.getItem("authToken");
    const id = data;
    // const updatedState = { ...data };
    // delete updatedState.boOwnerId;
    // delete updatedState.isActive;
    // delete updatedState.createdAt;
    // delete updatedState.createdBy;
    // delete updatedState.updatedAt;
    // delete updatedState.updateBy;
    // delete updatedState.departmentId;
    // delete updatedState.subDepartments;
    // updatedState.isActive = true;
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${UpdateDepartment}/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({isActive:true}),
        // body: JSON.stringify(updatedState),
      });

      if (response.ok) {
        const data = await response.json();
        getDepartmentList();
      } else {
        const data = await response.json();
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  useEffect(() => {
    getDepartmentList();
  }, []);
  const getDepartmentList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({isDeleted:false}),
      });

      if (response.ok) {
        const data = await response.json();
        const activeDepartment = data.data.filter((item) => item.isActive);
        const disabledDepartment = data.data.filter(
          (item) => item.isActive == false
        );
        setDepartmentData(activeDepartment);
        setDepartmentDisabledData(disabledDepartment);
        const newArray = activeDepartment.map((item) => ({
          value: item.departmentName,
          key: item.departmentId,
        }));
        sessionStorage.setItem("department", JSON.stringify(newArray));
        dispatch(setDept(newArray));
      } else {
        const data = await response.json();
        console.log("departmentserr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };
  const editSubDepartment = (departmentId, subDepartment) => {
    setDepartmentId(departmentId);
    setEditSubDeptFormData(subDepartment);
    setOpenSubDeptForm(true);
  };
  const addSubDepartment = (subdepartmentId) => {
    setSubDeptID(subdepartmentId);
    setOpenSubDeptForm(true);
  };
  const hideForm = () => {
    setOpenForm(false);
    setEditDepartmentData(null);
    getDepartmentList();
  };
  const hideSubdeptForm = () => {
    setOpenSubDeptForm(false);
    setEditSubDeptFormData(null);
    getDepartmentList();
  };
  const deleteDepartment = (deleteData) => {
    const token = localStorage.getItem("authToken");
    
    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${DeleteDepartment}/${deleteData?.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(deleteData.isDeleted ? {isDeleted: true}: {}),
      });

      if (response.ok) {
        const data = await response.json();
        getDepartmentList();
      } else {
        const data = await response.json();
        console.log("CompanyDataerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const deleteSubDepartment = ({ department, subDepartment, isDeleted }) => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(
        `${BASE_URL}/${UpdateSubDepartment}/${department?.departmentId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({
            subDeptId: subDepartment?.subDeptId,
            subDeptName: subDepartment?.subDeptName,
            subDeptShortName: subDepartment?.subDeptShortName,
            subDeptDescription: subDepartment?.subDeptDescription,
            ...(isDeleted == true && { isDeleted }),
            isActive: false,
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        getDepartmentList();
      } else {
        const data = await response.json();
        console.log("CompanyDataerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    fetchData();
  };
  const handleEdit = (department) => {
    setEditDepartmentData(department);
    setOpenForm(true);
  };

  const columns = [
    {
      headerName: "S. No.",
      field: "srno",
      width: '90px'
    },
    {
      headerName: "Department Name",
      field: "departmentname",
      width: '235px',
      autoHeight: true,
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[120px] h-[30px] inline-flex items-center">
                {capitalizeFirstLetter(params.data.departmentname)}
              </p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li
                      className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0"
                      key={index}
                    >
                      <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[100px] truncate items-center ml-2">
                        {capitalizeFirstLetter(data.subDeptName)}
                      </span>
                    </li>
                  ))}
                <li className="before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0 flex items-center mt-1">
                  <img
                    src={EditIcon}
                    onClick={() =>
                      addSubDepartment(params?.data?.item?.departmentId)
                    }
                    className="cursor-pointer w-3 h-3 ml-[13px]"
                  />
                  <span className="w-[75px] ml-[7px] inline-block"></span>
                </li>
              </ul>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Name (short)",
      field: "name",
      width: '220px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[120px] h-[30px] inline-flex items-center">
                {capitalizeFirstLetter(params.data.name)}
              </p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li
                      className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0"
                      key={index}
                    >
                      <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[100px] truncate items-center ml-2">
                        {capitalizeFirstLetter(data.subDeptShortName)}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Description",
      field: "description",
      width: '300px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[200px] h-[30px] inline-flex items-center">
                <span className="truncate">{capitalizeFirstLetter(params.data.description)}</span>
              </p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li
                      className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0"
                      key={index}>
                        <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 max-w-[150px] min-w-[100px] truncate items-center ml-2">
                          {capitalizeFirstLetter(data.subDeptDescription)}
                        </span>
                    </li>
                  ))}
              </ul>
            </div>
          </>
        );
      },
    },

    {
      headerName: "Action",
      field: "action",
      width: '180px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block ">
              <div className="flex mb-1">
                <span className="shi-pen">
                  <BsPencil onClick={() => handleEdit(params?.data?.item)} />
                </span>
                <span className="shi-not ml-2">
                  <StopOutlined
                    className="h-3"
                    onClick={() => deleteDept({ id : params?.data?.item.departmentId ,isDeleted:false})}
                  />
                </span>
                <span className="shi-not ml-2">
                  <DeleteOutlined
                    className="h-3"
                    onClick={() => deleteDept({ id : params?.data?.item.departmentId,isDeleted:true})}
                    />
                    </span>
              </div>
              <ul>
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li key={index}>
                      <div className="flex items-center mb-2">
                        <span className="shi-pen !text-xs bg-transparent h-5 w-5 ml-1">
                          <BsPencil
                            onClick={() =>
                              editSubDepartment(
                                params?.data?.item?.departmentId,
                                data
                              )
                            }
                          />
                        </span>
                        {/* <span className="w-5 h-5 items-center flex !ml-[22px] text-sm text-[#DC3848]">
                          <StopOutlined
                            onClick={() =>
                              deleteSubDept({
                                department: params?.data?.item,
                                subDepartment: data,
                                isDeleted:false
                              })
                            }
                            className="h-3 cursor-pointer"
                          />
                        </span> */}
                        <span className="w-5 h-5 items-center flex !ml-[18px] text-sm text-[#DC3848]">
                          <DeleteOutlined
                            onClick={() =>
                              deleteSubDept({
                                department: params?.data?.item,
                                subDepartment: data,
                                isDeleted:true
                              })
                            }
                            className="h-3 cursor-pointer"
                          />
                        </span>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
          </>
        );
      },
    },
  ];
  const disabledColumns = [
    {
      headerName: "S. No.",
      field: "srno",
      width: '90px'
    },
    {
      headerName: "Department Name",
      field: "departmentname",
      autoHeight: true,
      width: '235px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[120px] h-[30px] inline-flex items-center">
                {capitalizeFirstLetter(params.data.departmentname)}
              </p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map(
                    (data, index) =>
                      data.isActive == true && (
                        <li
                          className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0"
                          key={index}>
                            <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[100px] truncate items-center ml-2">
                              {capitalizeFirstLetter(data.subDeptName)}
                            </span>
                        </li>
                      )
                  )}
                  <li className="before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0 flex items-center mt-1">
                    <img
                      src={EditIcon}
                      onClick={() =>
                        addSubDepartment(params?.data?.item?.departmentId)
                      }
                      className="cursor-pointer w-3 h-3 ml-[13px]"
                    />
                    <span className="w-[75px] ml-[7px] inline-block"></span>
                  </li>
              </ul>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Name (short)",
      field: "name",
      width: '220px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 min-w-[120px] h-[30px] inline-flex items-center">{capitalizeFirstLetter(params.data.name)}</p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0" key={index}>
                      <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 w-[100px] truncate items-center ml-2">
                        {capitalizeFirstLetter(data.subDeptShortName)}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Description",
      field: "description",
      width: '300px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="block">
              <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[200px] h-[30px] inline-flex items-center">
                <span className="truncate">{capitalizeFirstLetter(params.data.description)}</span>
              </p>
              <ul className="flex flex-col items-end">
                {params?.data?.item?.subDepartments
                  ?.filter((data) => data.isActive)
                  .map((data, index) => (
                    <li className="mb-1 flex items-center before:w-1 before:h-1 before:bg-black before:rounded-full relative before:absolute before:left-0"
                       key={index}>
                        <span className="rounded-[28px] bg-[rgba(0,48,95,0.09)] text-xs px-3 py-1 max-w-[150px] min-w-[100px] truncate items-center ml-2">
                          {capitalizeFirstLetter(data.subDeptDescription)}
                        </span>
                    </li>
                  ))}
              </ul>
            </div>
          </>
        );
      },
    },
    {
      headerName: "Action",
      field: "action",
      width: '180px',
      cellRenderer: (params) => {
        return (
          <>
            <div className="flex">
              <span className="shi-pen ml-2">
                <PlusOutlined
                  onClick={() => activeBtnDepartment(params?.data?.item?.departmentId)}
                />
              </span>
              <span className="shi-not ml-2">
                  <DeleteOutlined
                    className="h-3"
                    onClick={() => deleteDept({ id : params?.data?.item.departmentId,isDeleted:true})}
                    />
                    </span>
            </div>
          </>
        );
      },
    },
  ];
  const rowData = departmentData.map((item, index) => ({
    key: index,
    item: item,
    srno: index + 1,
    departmentname: item.departmentName,
    name: item.departmentShortName,
    description: item.departmentDescription,
    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
        <StopOutlined
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#F5E7E9",
            borderRadius: "50%",
            fontSize: "10px",
            color: "#DC3545",
            marginLeft: "5px",
          }}
        />
      </div>
    ),
  }));
  const disabledRowData = departmentDisabledData.map((item, index) => ({
    key: index,
    item: item,
    srno: index + 1,
    departmentname: item.departmentName,
    name: item.departmentShortName,
    description: item.departmentDescription,
    actions: (
      <div
        className="flex"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <BsPencil
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#D7E7F8",
            borderRadius: "50%",
            fontSize: "17px",
          }}
        />
        <StopOutlined
          style={{
            border: "1px solid #D7E7F8",
            padding: "3px",
            backgroundColor: "#F5E7E9",
            borderRadius: "50%",
            fontSize: "10px",
            color: "#DC3545",
            marginLeft: "5px",
          }}
        />
      </div>
    ),
  }));

  return (
    <div>
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="grid grid-cols-12">
        <div className="col-span-8">
          <div className="flex justify-between mt-3 items-center">
            <p className="text-[17px] text-[#4B8AEB] font-sbold my-0 relative top-2">
              Active Department
            </p>
            <button
              onClick={() => setOpenForm(true)}
              className="h-[35px] border !border-[#00305F] !px-5 inline-flex items-center rounded-full font-sbold hover:bg-[#00305F] hover:text-white cursor-pointer transition-all"
            >
              +Add New Department
            </button>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12">
        <div className="col-span-8">
          <div className="ag-theme-alpine text-base border-none bodyAlignTop bordered" style={{ height: "auto", width: "100%", marginTop: "10px" }}>
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={columns}
              rowData={rowData}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={20}
              getRowHeight={() => 100}
              paginationPageSizeSelector={false}
            />{" "}
          </div>
        </div>
      </div>
      <p className="text-[17px] text-[#4B8AEB] font-sbold mt-0 mb-3 relative top-2">
        Disabled Department
      </p>
      <div className="grid grid-cols-12">
        <div className="col-span-8">
          <div className="ag-theme-alpine text-base border-none bodyAlignTop bordered" style={{ height: "auto", width: "100%", marginTop: "10px" }}>
            <AgGridReact
              gridOptions={gridOptions}
              columnDefs={disabledColumns}
              rowData={disabledRowData}
              domLayout="autoHeight"
              pagination={true}
              paginationPageSize={20}
              paginationPageSizeSelector={false}
            />
          </div>
        </div>
      </div>
      <DepartmentForm
        visible={openForm}
        onCancel={hideForm}
        editItem={editDepartmentData}
      />
      <SubDepartmentForm
        visible={openSubDeptForm}
        onCancel={hideSubdeptForm}
        editItem={editSubDeptFormData}
        departmentId={departmentId}
        addSubdeptId={subDeptID}
      />
      <ModalConfirm
        visible={modalDeleteDeptVisible}
        onOk={() => handleOk(deleteDeptData)}
        onCancel={handleCancel}
        title={`${deleteDeptData?.isDeleted ? 'Delete' : 'Disable'}`}
        content={`Are you sure you want to ${deleteDeptData?.isDeleted ? 'delete?' : 'disable?'}`}
      />
      <ModalConfirm
        visible={modalDeleteSubDeptVisible}
        onOk={() => handleSubOk(deleteSubDeptData)}
        onCancel={handleSubCancel}
        title={`${deleteSubDeptData?.isDeleted ? 'Delete' : 'Delete'}`}
        content={`Are you sure you want to ${deleteSubDeptData?.isDeleted ? 'delete?' : 'delete?'}`}
      />
      <ModalConfirm
        visible={modalActiveDepartmentVisible}
        onOk={() => handleActiveOk(activeDepartmentData)}
        onCancel={handleActiveCancel}
        title="Enable"
        content="Are you sure you want to enable?"
      />
    </div>
  );
}

export default Department;
